(() => {
 const selector = '#yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-button';
 function update(){
  document.querySelectorAll(selector).forEach(button=>{
   const label=button.getAttribute('aria-label')||'';
   const match=label.match(/(?:מבוסס(?:ת)? על)\s*([\d,.]+)\s*(?:ביקורות|חוות דעת)/)||label.match(/(?:based on)\s*([\d,.]+)\s*(?:reviews|ratings)/i);
   if(!match) return;
   const hebrew=/ביקורות|חוות דעת/.test(label);
   const text=match[1]+(hebrew?' ביקורות':' reviews');
   let count=button.querySelector('.yf-rating-count');
   if(!count){count=document.createElement('span');count.className='yf-rating-count';count.setAttribute('aria-hidden','true');button.append(count);}
   if(count.textContent!==text) count.textContent=text;
   if(!button.classList.contains('yf-rating-count-ready')) button.classList.add('yf-rating-count-ready');
  });
 }
 let scheduled=false;
 const observer=new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;update();});});
 observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-label']});
 update();
})();